<div class="hb-container hb-container--width-lg">
  <div class="hb-grid">
    <div class="hb-cell hb-cell--12of12 hb-cell--3of12@md">
      <stat-filter (selectedFilters)="filterVisning($event)" seksjon="bostotte"></stat-filter>
    </div>
    <div class="hb-cell hb-cell--12of12 hb-cell--9of12@md" id="testing">
      <h1 class="hb-h1 hb-text--3xl hb-avstand--avsnitt">Bostøtte</h1>
      <hb-accordion class="hb-mb--lg">
        <hb-accordion-element id="bostoetteID">
          <h2 title class="hb-accordion-tittel">Om bostøtte</h2>
          <div body="">
            <p>
              Formålet med den statlige bostøtten er å sikre personer med lave inntekter og høye boutgifter et godt sted å bo. Bostøtten som blir utbetalt, blir utregnet som en
              fastsatt prosent av differansen mellom godkjente boutgifter og en egenandel. Egenandel blir fastsatt ut fra inntekten og formuen til husstanden.
            </p>
            <h3>Valg av utbetalingsperiode</h3>
            <p>
              Utbetaling av bostøtte skjer i påfølgende måned for måneden du søker for. I statistikkbanken kan du derfor velge mellom å se statistikk for utbetaling for måneden
              søknaden gjelder (termin), eller måneden bostøtten faktisk ble utbetalt (regnskapsført).
            </p>
            <p>
              I Husbankens statistikk brukes som regel førstnevnte på månedsnivå, mens det på årsnivå er utbetalingsmåneden som er gjeldende fordi man tar hensyn til budsjettåret
              utbetalingen blir regnskapsført. Utbetalingsåret 2018 er dermed det samme som terminmånedene desember 2017 til november 2018.
            </p>
            <h3>Inntekts- og boutgiftsstatistikk</h3>
            <p>
              All statistikk gjelder husstanden som helhet, altså er det husstandens samlede inntekter og boutgifter som inngår i beregningen. Hvilke inntekter og boutgifter som
              inngår i beregningen av bostøtte finner du på husbanken.no.
            </p>

            <h3>Brukergrupper</h3>
            <p>
              1.1.2017 ble det gjort vesentlige endringer mellom brukergrupper «Husstander med midlertidige trygdeytelser» og «Husstander uten trygdeytelser». Disse brukergruppene
              bør derfor ikke inngå i sammenligninger som gjøres lenger tilbake enn 1.1.2017.
            </p>
          </div>
        </hb-accordion-element>
      </hb-accordion>

      <fieldset class="hb-felt">
        <legend class="hb-screenreader-only">Sorter etter</legend>
        <div class="hb-buttongroup">
          <input name="typeTilstand" class="hb-radiobutton" id="typeTilstandSoknad" type="radio" (click)="filterTilstand('Søknad')" />
          <label class="hb-button hb-button--standard" for="typeTilstandSoknad">Søknad</label>

          <input name="typeTilstand" class="hb-radiobutton" id="typeTilstandTerminutbetaling" type="radio" (click)="filterTilstand('Terminutbetaling')" />
          <label class="hb-button hb-button--standard" for="typeTilstandTerminutbetaling">Terminutbetaling</label>

          <input name="typeTilstand" class="hb-radiobutton" id="typeTilstandUtbetaling" type="radio" checked="" (click)="filterTilstand('Utbetaling')" />
          <label class="hb-button hb-button--standard" for="typeTilstandUtbetaling">Utbetaling</label>

          <input name="typeTilstand" class="hb-radiobutton" id="typeTilstandAvslag" type="radio" (click)="filterTilstand('Avslag')" />
          <label class="hb-button hb-button--standard" for="typeTilstandAvslag">Avslag</label>
        </div>
      </fieldset>

      @if (statistikkType === "Søknad") {
        <div class="hb-grid">
          <stat-kpitabell [kpiIder]="kpiListeForSoknad" [valgtFilter]="valgtFilter" [statistikkType]="statistikkType" class="hb-cell hb-cell--6of12@md"></stat-kpitabell>
        </div>
      }
      @if (statistikkType === "Utbetaling") {
        <div class="hb-grid">
          <stat-kpitabell [kpiIder]="kpiListeForUtbetaling" [valgtFilter]="valgtFilter" [statistikkType]="statistikkType" class="hb-cell hb-cell--6of12@md"></stat-kpitabell>
        </div>
      }
      @if (statistikkType === "Terminutbetaling") {
        <div class="hb-grid">
          <stat-kpitabell [kpiIder]="kpiListeForUtbetaling" [valgtFilter]="valgtFilter" [statistikkType]="statistikkType" class="hb-cell hb-cell--6of12@md"></stat-kpitabell>
        </div>
      }
      @if (statistikkType === "Avslag") {
        <div class="hb-grid">
          <stat-kpitabell [kpiIder]="kpiListeForAvslag" [valgtFilter]="valgtFilter" [statistikkType]="statistikkType" class="hb-cell hb-cell--6of12@md"></stat-kpitabell>
        </div>
      }

      <div class="hb-grid">
        <div class="hb-fieldset hb-cell hb-cell--12of12">
          <div class="hb-legend">
            <div class="hb-legend-tekst" id="hva-du-vil-se" aria-hidden="true">Velg hva du vil se:</div>
            <hb-hjelpetekst labelledby="hva-du-vil-se">
              @for (item of objectKeys(typeTekst[statistikkType]); track item) {
                <div>
                  <p class="hb-avstand--ingen">
                    <strong>{{ typeTekst[statistikkType][item][0] }}:</strong>
                  </p>
                  <p class="hb-avstand--avsnitt">{{ typeTekst[statistikkType][item][1] }}</p>
                </div>
              }
            </hb-hjelpetekst>
          </div>
          <fieldset class="hb-felt">
            <legend class="hb-legend" class="hb-screenreader-only">Velg hva du vil se:</legend>
            <ul class="hb-feltliste hb-feltliste--horisontal">
              @for (value of objectKeys(typeTekst[statistikkType]); track value) {
                <li>
                  <input
                    (change)="selectedRadio($event)"
                    class="hb-radiobutton"
                    [id]="value"
                    type="radio"
                    name="radio1"
                    [value]="value"
                    [checked]="statistikkType === 'Avslag' || statistikkType === 'Søknad' ? value === 'soknader' : value === graferValgt"
                  />
                  <div class="hb-label">
                    <label class="hb-label-tekst" [for]="value">
                      <span>{{ typeTekst[statistikkType][value][0] }}</span>
                    </label>
                  </div>
                </li>
              }
            </ul>
          </fieldset>

          <stat-kommunefilter></stat-kommunefilter>
        </div>
      </div>

      @if (statistikkType === "Søknad") {
        <div class="hb-grid">
          @for (soknadId of grafIderForSoknad; track soknadId) {
            <stat-qlik-graf
              id="{{ soknadId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }

      @if ((statistikkType === "Utbetaling" || statistikkType === "Terminutbetaling") && graferValgt === "soknader") {
        <div class="hb-grid">
          @for (utbetaltId of grafIderForUtbetalt; track utbetaltId) {
            <stat-qlik-graf
              id="{{ utbetaltId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }

      @if (graferValgt === "belop" && (statistikkType === "Utbetaling" || statistikkType === "Terminutbetaling")) {
        <div class="hb-grid">
          @for (belopId of grafIderForBelop; track belopId) {
            <stat-qlik-graf
              id="{{ belopId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }

      @if (graferValgt === "utbetalt" && (statistikkType === "Utbetaling" || statistikkType === "Terminutbetaling")) {
        <div class="hb-grid">
          @for (gjsnittId of grafIderForGjennomsnitt; track gjsnittId) {
            <stat-qlik-graf
              id="{{ gjsnittId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }

      @if (statistikkType === "Avslag") {
        <div class="hb-grid">
          @for (avslagId of grafIderForAvslag; track avslagId) {
            <stat-qlik-graf
              id="{{ avslagId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }
    </div>
  </div>
</div>
